import React, { useState, useEffect } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { calculateEntropy, estimateTimeToCrack } from '../../utils/passwordUtils';
import PasswordDisplay from '../PasswordDisplay/PasswordDisplay';

const ValidatePassword = () => {
  const [password, setPassword] = useState('');
  const [passwordData, setPasswordData] = useState({
    password: '',
    entropy: 0,
    timeToCrack: 0,
  });

  useEffect(() => {
    if (password.trim() === '') {
      setPasswordData({ password: '', entropy: 0, timeToCrack: 0 });
      return;
    }

    const entropy = calculateEntropy(password, password.length * 26);
    const timeToCrack = estimateTimeToCrack(entropy);

    setPasswordData({ password, entropy, timeToCrack });
  }, [password]);

  return (
    <Box sx={{ textAlign: 'center', marginTop: '2rem' }}>
      <Typography variant="h5" sx={{ marginBottom: '1rem' }}>
        Validate Your Password
      </Typography>

      {/* Password Input */}
      <TextField
        variant="outlined"
        placeholder="Enter your password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        sx={{
          marginBottom: '1rem',
          backgroundColor: 'background.paper',
          borderRadius: '8px',
        }}
      />

      {/* Password Validation Results */}
      <PasswordDisplay
        password={passwordData.password}
        entropy={passwordData.entropy}
        timeToCrack={passwordData.timeToCrack}
        hideRegenerate={true}
        viewPassword={false}
      />
    </Box>
  );
};

export default ValidatePassword;
